import styled from "styled-components";
import { beforeCss } from "../../atom";

export const FoxNormalRechargeWrapper = styled.div``;

export const MemberCard = styled.div<{ bg?: string }>`
  width: 224px;
  height: 134px;
  box-shadow: inset 0 0 0 1px rgba(73, 83, 89, 1);
  background: #292b2f;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  cursor: pointer;
  padding: 18px 14px;
  &.active {
    background: rgba(243, 81, 43, 0.04);
    ${beforeCss};
  }

  :hover {
    background: rgba(243, 81, 43, 0.04);
    ${beforeCss};
  }
`;

export const CommonStyle = styled.div`
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &.isDiamond {
    height: 100%;
  }
`;

export const Price = styled(CommonStyle)`
  margin: 7px 0 15px;
  font-weight: 500;
  font-size: 30px;
  height: 42px;
  .unit {
    font-size: 16px;
    font-weight: 400;
  }
  &.isDiamond {
    margin: 0;
  }
`;

export const Level = styled(CommonStyle)`
  font-size: 14px;
  line-height: 20px;
`;
